import { format,isValid,parseISO } from "date-fns";

import { IssuesState, TripsState } from "types/store";
import { DATE_FORMAT, FULL_DATE_FORMAT } from "../constants";

import {
  getDateFromSeconds,
  getRandomNumber,
  getRandomString,
} from "../helpers";
import { getFormatedDate } from "store/actions";
import { formatDate } from "./date-parser";


export function parseTripsTable(
  list?: TripsState["tripsCenter"],
) {
  if (list) {
    const data = list.map((trips, index) => ({
      key: index,
      id: trips.id,
      vehicle_id: trips.vehicle_id,
      rider_name: trips.rider_name,
      start_time: formatDate(trips.start_time), 
      end_time:  formatDate(trips.end_time), 
      total_km: trips.total_km,
      score:  trips.score
          ? Number(trips.score).toFixed(2)
          : "-",
      soc_used: trips.soc_used,
      total_battery: trips.total_battery || 1,
      raw: trips,
    }));

    return data;
  }
  return [];
}



export function parseTripCoordinate(
    coordinate: TripsState["tripCoordinate"]
) {
    if (coordinate) {
      const data = coordinate.map((co, index) => ({
        lat: co.lat,
        lng: co.lng,
      }));

      return coordinate
    }
    return [];
}
